/**
 * @typedef {import('@/types/promotionTypes.js').SegmentDetails} SegmentDetails
 */

import {Tag} from '@/components/atoms'

/**
 * @typedef {Object} SegmentTagsProps
 * @property {SegmentDetails[]} tags - Array of segment details to display as tags
 * @property {(id: string) => void} handleTagRemove - Callback to handle tag removal
 * @property {string} color - Color of the tag
 * @property {boolean} showAnd - Whether to show "AND" between tags
 */

/**
 * Component for displaying segment tags
 * @param {SegmentTagsProps} props
 */
export const SegmentTags = ({segments, handleTagRemove, color = 'blue', showAnd = false}) => {
  return (
    <div className="mb-4 mt-4 flex flex-row flex-wrap items-center gap-2">
      {segments?.length > 0 &&
        segments?.map((seg, index) => {
          return (
            <>
              <Tag
                key={seg.segmentId}
                id={seg.segmentId}
                text={seg.segmentName}
                isRemovable={true}
                color={color}
                onRemove={() => handleTagRemove(seg)}
              />
              {showAnd && index < segments.length - 1 && <span className="text-sm font-medium text-white">AND</span>}
            </>
          )
        })}
    </div>
  )
}
